module.exports = __webpack_public_path__ + "media/images/user-workflow-749c7cb7e5463dbbe4184145fd1b5a69.svg";